import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const leaveGroup = createAsyncThunk<void, string, { state: RootState }>(
  'groups/leave',
  async (groupId, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    const updatedGroup = await groupsService.leaveGroup({
      groupId,
    });

    dispatch(entitiesActions.upsertGroup(updatedGroup));
  },
);
